import type { AplicarSimulacaoDialogProps } from "./types-aplicar-simulacao-dialog";
import { useAplicarSimulacaoDialog } from "./use-aplicar-simulacao-dialog";
import { AplicarSimulacaoDialogView } from "./view-aplicar-simulacao-dialog";

/** "Aplicar Simulação" (HU 2221): revisão dos cartões, justificativa geral e gravação num POST. */
export function AplicarSimulacaoDialog(props: AplicarSimulacaoDialogProps) {
  const vm = useAplicarSimulacaoDialog(props);

  return <AplicarSimulacaoDialogView {...vm} />;
}

export type * from "./types-aplicar-simulacao-dialog";
